module.exports = __webpack_public_path__ + "img/icon-payment-nfc.eb85671f.png";